import { Box, Paper, Stack, TablePagination } from '@mui/material';
import { flexRender } from '@tanstack/react-table';
import {
  AppTable,
  AppTableBody,
  AppTableCell,
  AppTableContainer,
  AppTableHead,
  AppTableRow,
  AppTableSort,
} from '../../../components/common/app-table/ui';
import useDefaultTable from '../../../components/common/app-table/useDefaultTable';
import LoadingIndicator from '../../../components/common/LoadingIndicator';
import AppSearchField from '../../../components/common/forms/AppSearchField';

import { ICertificateTracker } from './ct-utils';
import ctColumns from './ctColumns';

import { useGetCertificateTracker } from '../../../hooks/useCertificateTracker';
import { usePermission } from "../../../hooks/usePermissions";
import { Modules, Permissions } from "../../Users/Roles/roles-utils";
import { Navigate } from 'react-router-dom';

const CtTable = () => {
  const hasPermission = usePermission(Modules.ec.accessKey);

  const hasEditPermission = usePermission(
    Modules.ec.accessKey,
    Permissions.edit
  );

  const hasEmailPermission = usePermission(
    Modules.ec.accessKey,
    Permissions.email
  );

  const certificates = useGetCertificateTracker();
  const data: ICertificateTracker[] = certificates?.data === undefined ? [] : certificates?.data;

  const { table, dataCount, searchFilter, setSearchFilter, pageIndex, pageSize } =
    useDefaultTable<ICertificateTracker>(data, ctColumns());

  if (!hasPermission) return <Navigate to="/home" />;

  const emptyText = searchFilter ? 'No equipments found' : 'No equipments yet';

  if (certificates?.isLoading) return <LoadingIndicator show />;

  return (
    <>
      <Stack direction='row' justifyContent='flex-end' alignItems='center' mb={2}>
        <AppSearchField
          onSearchKeywordChange={setSearchFilter}
          searchKeyword={searchFilter ?? ''}
        />
        {/* {table
          .getAllLeafColumns()
          .filter((c) => c.columnDef.enableHiding)
          .map((column) => (
            <TableColumnFilter columnsToFilter={column} key={column.id} />
          ))}
        <ImportButton /> */}
      </Stack>
      <Paper elevation={3}>
        <AppTableContainer>
          <AppTable stickyHeader>
            <AppTableHead>
              {table.getHeaderGroups().map((headerGroup) => (
                <AppTableRow key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <AppTableCell key={header.id} align='center'>
                      <AppTableSort
                        canSort={header.column.getCanSort()}
                        currentSort={header.column.getIsSorted()}
                        onSort={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </AppTableSort>
                    </AppTableCell>
                  ))}
                </AppTableRow>
              ))}
            </AppTableHead>
            <AppTableBody
              dataCount={dataCount}
              // loading={loading}
              emptyText={emptyText}
            >
              {table.getRowModel().rows.map((row) => (
                <AppTableRow key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <AppTableCell key={cell.id} align='center' style={{padding: (!hasEditPermission && !hasEmailPermission ? '12px': undefined)}}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </AppTableCell>
                  ))}
                </AppTableRow>
              ))}
            </AppTableBody>
          </AppTable>
        </AppTableContainer>
        <Box position='relative'>
          <TablePagination
            sx={{ bgcolor: 'white', borderTop: '1px solid #eee' }}
            component='div'
            count={dataCount}
            page={pageIndex}
            onPageChange={(e, page) => table.setPageIndex(page)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(e) => table.setPageSize(Number(e.target.value))}
            rowsPerPageOptions={[10, 20, 50, 100]}
          />
        </Box>
      </Paper>{' '}
    </>
  );
};

export default CtTable;
